import { render, staticRenderFns } from "./SearchHeaderWidgetRecents.vue?vue&type=template&id=65d36d94&"
import script from "./SearchHeaderWidgetRecents.vue?vue&type=script&lang=js&"
export * from "./SearchHeaderWidgetRecents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports